import type { Module } from 'vuex';
import { Action } from '@/types/Action';
import {RootState} from "@/store";

export interface ActionState {
  action: Action | null;
  deleted: boolean;
}

const actionModule: Module<ActionState, RootState> = {
  namespaced: true,
  state: (): ActionState => ({
    action: null,
    deleted: false,
  }),
  mutations: {
    setAction(state, payload: any) {
      if (payload === null) {
        state.action = null;
        state.deleted = false;
        return;
      }
      state.action = Action.fromRaw(payload);
      state.deleted = false;
    },
    setActionUpdate(state, payload: any) {
      if (!state.action || state.action.idAction !== payload.idAction) return;
      if (payload.name !== undefined) state.action.name = payload.name;
      if (payload.orphan !== undefined) state.action.orphan = payload.orphan;
    },
    setActionDelete(state, payload: { idAction: number }) {
      if (state.action?.idAction === payload.idAction) {
        state.deleted = true;
      }
    },
    clearAction(state) {
      state.action = null;
      state.deleted = false;
    },
  },
  actions: {
    wsSetAction({ commit }, payload) {
      commit('setAction', payload);
    },
    wsSetEmptyAction({ commit }) {
      commit('setAction', null);
    },
    wsActionUpdate({ commit }, payload) {
      commit('setActionUpdate', payload);
    },
    wsActionDelete({ commit }, payload) {
      commit('setActionDelete', payload);
    },
    clearAction({ commit }) {
      commit('clearAction');
    },
  },
};

export default actionModule;
